(function($) {

	$.fn.initStickyBuyButton = function() {

		return this.each(function() {

			var $this = $(this);
			var $window = $(window);
			var thisH = $this.outerHeight(true);
			var topH = $("#navbar").height();
			var $placeholder;
			var $bottomMarginPlaceholder = $("<div></div>").css("height", (thisH - 15));

			$this.wrap("<div class='buy-button-placeholder'></div>");
			$placeholder = $this.parent();
			$placeholder.height(thisH);

			$window.scroll(scrollHandler);

			function scrollHandler() {
				var shouldBeSticky;

				if ($placeholder.offset().top + thisH < $window.scrollTop() + topH) {
					shouldBeSticky = true;
				} else {
					shouldBeSticky = false;
				}

				if ($this.is(".sticked")) {
					if (!shouldBeSticky) {
						$this.removeClass("sticked-visible sticked");
						$bottomMarginPlaceholder.detach();
					}
				} else {
					if (shouldBeSticky) {
						$this.addClass("sticked");
						window.setTimeout(function() {
							$this.addClass("sticked-visible");
						}, 50);
						$bottomMarginPlaceholder.appendTo("#content");
					}
				}				
			}

			scrollHandler();

		});

	};

})(jQuery);

